// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"loading-skeleton_skeleton__j_0K9","shimmer":"loading-skeleton_shimmer__eRWY_"};